// event-bus.js
import Vue from 'vue';


const ComponentEventBus = new Vue();
export default ComponentEventBus;

export const Events = {
    ADD : 'component-wrapper-add',
    REMOVE: 'component-wrapper-remove'
}


//standard model for the modal
export interface IComponentWrapper{
    type: string; //component name ex. 'modal-text-component'
}




ComponentEventBus.$on(Events.ADD, (payload: any) => {
    console.log('something is happening..');
});


